// Import FirebaseAuth and firebase.
import React, { useEffect, useState } from 'react';
import StyledFirebaseAuth from './StyalizedFirebaseAuth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import styles from "./SignInScreen.module.css"
import { OAuthProvider, deleteUser, getAdditionalUserInfo } from 'firebase/auth';

// Configure Firebase.
const config = {
  apiKey: 'AIzaSyCuR-Eu_x5VuNXmx4MSe04wNCSPHZ-bVXU',
  authDomain: 'lanota-67543202.firebaseapp.com',
  // ...
};
firebase.initializeApp(config);
const appleAuthProvider = new OAuthProvider('apple.com');

// Configure FirebaseUI.
const uiConfig: firebaseui.auth.Config = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    {provider:firebase.auth.GoogleAuthProvider.PROVIDER_ID, disableSignUp: {status: true} },
    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    firebase.auth.TwitterAuthProvider.PROVIDER_ID,
    {provider:firebase.auth.EmailAuthProvider.PROVIDER_ID, disableSignUp: {status: true} },
    "apple.com"
  ],
 
};

function SignInScreen() {
  const [isSignedIn, setIsSignedIn] = useState(false); // Local signed-in state.
  const [noAccount, setNoAccount] = useState(false);
  const [readyToDelete, setReadyToDelete] = useState(false);


  uiConfig.callbacks = {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: (authRresult: any, _) =>{

      const userInfo = authRresult.additionalUserInfo??null;
      console.log(JSON.stringify(authRresult));
      if(!userInfo){
        console.log("no user info");
        
      }
      if(userInfo?.isNewUser){
          console.log("new user");
          deleteUser(authRresult.user);
          setNoAccount(true);

          return false;
      }else if(!userInfo?.isNewUser){
          console.log("not new user");
          setNoAccount(false);
      }
      return true;
    },
  };
  // Listen to the Firebase Auth state and set the local state.
  useEffect(() => {
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
      setIsSignedIn(!!user);
      
    });
    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);

  const appleSuccessHandler = (result: any) => {
      console.log(result);
  }

  const appleFailedHandler = (error: any) => {
      console.log(error);
  }

  if(noAccount){
    return(
      <div>
        <h1 className={styles.title}>Lanota (Noxygames Inc.)</h1>
        <p>There is no account associated with this login method</p>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
        
      </div>
    )
  }

  if (!isSignedIn) {
    return (
      <div>
        <h1 className={styles.title}>Lanota (Noxygames Inc.)</h1>
        <p>Please sign-in:</p>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
        
      </div>
    );
  }
  

 

  if(readyToDelete){
    return (
      <div>
      <h1 className={styles.title}>Lanota (Noxygames Inc.)</h1>     
      <span className={styles.alertText}>WARNING: </span>
      <p className={styles.alertText}>DELETE ACCOUNT means you will lose all game data and never get it back again. Really want to delete account { firebase.auth().currentUser?.displayName}?</p>
      
      <button className={styles.deleteButton} onClick={() => {firebase.auth().currentUser?.delete();setIsSignedIn(false); setReadyToDelete(false);alert("Account deleted!!\nFarewell")}}>YES</button>
      <button className={styles.button} onClick={() =>setReadyToDelete(false)}>NO</button>
     </div>
    );
  }

  return (
    <div>
      <h1>Lanota (Noxygames Inc.)</h1>
      <p>Welcome { firebase.auth().currentUser? firebase.auth().currentUser?.displayName:"No User"}! You are now signed-in!</p>
      <button className={styles.button} onClick={() => firebase.auth().signOut()}>Sign-out</button>
      <button className={styles.deleteButton} onClick={()=>setReadyToDelete(true)}>Delete Account</button>
    </div>
  );
}

export default SignInScreen;